// extracted by mini-css-extract-plugin
module.exports = {"uploadImgWrp":"uploadImg_uploadImgWrp__amW8b","imagesList":"uploadImg_imagesList__2bnvB","uploadBlock":"uploadImg_uploadBlock__3y3xt","imgChooser":"uploadImg_imgChooser__CyFnl"};